import {Component, OnDestroy, OnInit} from '@angular/core';
import { BehaviorSubject, first, Observable,shareReplay, Subject, withLatestFrom } from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../shared/service/loader.service';
import {ComponentHelper, PreviewDocumentService} from '@utils-lib';
import {FrontendDocument, NachdigalService} from '@nachdigal';

@Component({
  selector: 'frageboegen-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})

export class PdfViewerComponent implements OnInit,OnDestroy {
  appType$ = new BehaviorSubject<string>(null);
  taskId$ = new BehaviorSubject<string>(null);
  docId$ = new BehaviorSubject<string>(null)
  frontendCocument$ : Observable<FrontendDocument>;
  closeButtonClick = new Subject();
  public pdfBlob$ :Observable<Blob>;

  constructor(private readonly route: ActivatedRoute,
              private readonly loadingService: LoaderService,
              private readonly router: Router,
              protected nachdigalService: NachdigalService,
              private readonly previewDocumentService: PreviewDocumentService) {
    document.body.classList.remove('genepool');
    document.body.classList.add('dackl-basic');

    route.params.pipe(first()).subscribe(params=>{
      this.appType$.next(params.appName);
      this.taskId$.next(params.nid);
      this.docId$.next(params.docId)
    });
    this.frontendCocument$ =  nachdigalService.getDocumentIds(this.taskId$.value).pipe(
      first(),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  ngOnInit(): void {
    if(this.docId$.value){
      this.pdfBlob$ = this.previewDocumentService.getSingleFilePdfBlob(this.taskId$.value, this.docId$.value).pipe(
        first(),
        shareReplay({bufferSize: 1, refCount: true})
      );
    } else {
      this.pdfBlob$ = this.previewDocumentService.getPdfBlob(this.taskId$.value, false, ComponentHelper.pathToAppNameEnum(this.appType$.value)).pipe(
        first(),
        shareReplay({bufferSize: 1, refCount: true})
      );
    }
    this.closeButtonClick.pipe(first()).subscribe(() => history.back());
  }

  public onDownloadDocument(): void {
    this.frontendCocument$.pipe(
      first(),
      withLatestFrom( this.pdfBlob$)
      ).subscribe( ([frontedDoc, blob]) =>{
        const anchor = document.createElement('a');
        anchor.download = frontedDoc.filename;
        anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
        anchor.click();
      }
    );
  }

  public onCloseFullScreen(): void {
    this.closeButtonClick.next('');
    this.previewDocumentService.onClosePdfViewer.emit();

  }

  ngOnDestroy(): void {
    document.body.classList.add('genepool');
    document.body.classList.remove('dackl-basic');
  }
}
